import { Input, InputProps } from 'antd';
import React from 'react';

interface CustomInputProps extends InputProps {
  title?: string;
  required?: boolean;
  width?: string;
  background?: string;
  height?: string;
  error?: any;
  defaultValue?: string;
  controls?: boolean;
  fontSize?: string | number;
  errors?: any;
}
const CustomInput: React.FC<CustomInputProps> = ({
  title,
  required,
  width,
  height,
  background,
  defaultValue,
  disabled,
  error,
  fontSize,
  errors,
  ...props
}) => {
  const CustomInputStyle = {
    border: disabled
      ? 'none'
      : error || errors?.[props.name]
      ? '1px solid red'
      : '0.5px solid #407FDD',
    borderRadius: '0.375rem',
    padding: '8px 16px',
    height: height ? height : '58px',
    background: disabled ? '#E4E4E4' : background,
    cursor: disabled ? 'not-allowed' : 'pointer',
    // opacity: disabled && '0.7',
  };
  return (
    <div
      style={{
        width: width || '55%',
        overflow: 'hidden',
      }}
    >
      <div className="CustomInput">
        <div style={CustomInputStyle}>
          <span
            style={{
              lineHeight: '12px',
              display: 'block',
            }}
          >
            <span
              style={{
                color: '#898989',
                fontSize: '10px',
                fontWeight: 400,
                whiteSpace: 'nowrap',
              }}
            >
              {' '}
              {title}
            </span>{' '}
            <span style={{ color: '#E02C2C', fontSize: 10, fontWeight: 400 }}>
              {required && '*'}
            </span>
          </span>
          <Input
            autoComplete={'off'}
            defaultValue={defaultValue}
            {...props}
            bordered={false}
            style={{
              padding: 0,
              borderRadius: '0px',
              cursor: disabled ? 'not-allowed' : 'pointer',
              pointerEvents: disabled ? 'none' : 'auto',
              fontSize: fontSize && fontSize,
            }}
            size={'large'}
          />
        </div>
      </div>
      {errors?.[props.name] && (
        <div
          style={{
            fontSize: 10,
            color: '#E02C2C',
            fontWeight: 500,
            marginTop: 2,
          }}
        >
          {errors?.[props.name]}
        </div>
      )}
    </div>
  );
};

export default CustomInput;
